module.exports = __webpack_public_path__ + "img/428.06d28311.jpg";